import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { mainApi } from "../providers/api";
import { FaArrowLeft } from "react-icons/fa6";
import objectPath from "object-path";
import { API_ROOT } from "../defines";
import { useApp } from "../providers/app";
import { useTranslation } from "react-i18next";
import Loading from "../components/Loading";
import Counter from "./components/Counter";
import Select from "react-select";
import Swal from "sweetalert2";
const Detail = () => {
  const { t } = useTranslation();
  const { refreshNoti } = useApp();
  const { id } = useParams();
  const [data, setdata] = useState();
  const [loading, setloading] = useState(false);
  const [material, setmaterial] = useState(null);
  const [materiallist, setmateriallist] = useState(null);
  const [size, setsize] = useState(null);
  const [sizelist, setsizelist] = useState(null);
  const [price, setPrice] = useState(null);
  const [priceObj, setPriceObj] = useState(null);
  const [priceLoading, setpriceLoading] = useState(false);
  const [count, setcount] = useState(1);
  const [cart, setCart] = useState([]);

  const navigate = useNavigate();

  const basket = () => {
    const isCoat = objectPath.get(priceObj, "coat") == price;
    const sizeObj = sizelist?.find((row) => row._id == size);
    const materialObj = materiallist?.find((row) => row._id == material);
    const temp = [
      {
        id: id,
        type: "normal",
        name: objectPath.get(data, "name"),
        image: objectPath.get(data, "image.0.id"),
        size: size,
        sizeObj: sizeObj,
        material: material,
        materialObj: materialObj,
        isCoat: isCoat,
        price: price,
        count: count,
        total_price: price * count,
      },
      ...cart,
    ];
    localStorage.setItem("cart", JSON.stringify(temp));
    refreshNoti();
    Swal.fire({
      icon: "success",
      title: "已成功添加到您的购物车。",
      // title: "Таны сагсанд амжилттай нэмэгдлээ.",
      confirmButtonText: "命令",
      // confirmButtonText: "Захиалах",
      confirmButtonColor: "#1A2E55",
      denyButtonColor: "#9EA1A1",
      denyButtonText: "添加产品",
      // denyButtonText: "Бүтээгдэхүүн нэмэх",
      showDenyButton: true,
    }).then((result) => {
      if (result.isConfirmed) navigate("/order/basket");
      else navigate("/order/home");
    });

    // localStorage.clear();
  };
  useEffect(() => {
    const savedCart = localStorage.getItem("cart");
    console.log("🚀 ~ useEffect ~ savedCart:", savedCart);
    if (savedCart) {
      setCart(JSON.parse(savedCart));
    }
  }, []);

  useEffect(() => {
    const fetch = async () => {
      try {
        setloading(true);
        const result = await mainApi({
          url: `/service/sign/${id}`,
          method: `GET`,
          auth: {
            username: "hsct",
            password:
              "769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df",
          },
        });
        console.log("🚀 ~ fetch ~ result:", result.data);
        document.title = objectPath.get(result, "data.seo");
        setmateriallist(objectPath.get(result, "data.materialList"));
        setsizelist(objectPath.get(result, "data.sizeList"));
        setdata(objectPath.get(result, "data"));
        setloading(false);
      } catch (err) {
        setloading(false);
      }
    };
    fetch();
  }, [id]);

  useEffect(() => {
    const getPrice = async () => {
      try {
        setpriceLoading(true);
        const result = await mainApi({
          url: `/service/sign/price`,
          method: `POST`,
          auth: {
            username: "hsct",
            password: `769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df`,
          },
          data: {
            material: material,
            size: size,
          },
        });

        setPriceObj(objectPath.get(result, "data"));
        setpriceLoading(false);
      } catch (err) {
        setpriceLoading(false);
        console.log("err", err);
      }
    };
    size && material && getPrice();
  }, [size, material]);

  return (
    <div className='flex p-8 w-full pb-32'>
      {loading ? (
        <Loading width='w-16' />
      ) : (
        <div className='flex flex-col w-full'>
          <div className='flex items-center'>
            <div
              onClick={() => navigate(-1)}
              className='flex w-8 h-8 justify-center items-center border border-primary rounded-md hover:cursor-pointer'
            >
              <FaArrowLeft color='#1A2E55' size={15} />
            </div>
            <div className='font-medium ml-2'>
              {`${objectPath.get(data, "type.type")} -  ${objectPath.get(
                data,
                "name"
              )}`}
            </div>
          </div>
          <div className='flex flex-wrap w-full mt-4'>
            <div className='flex md:w-1/4 w-full  justify-center'>
              <div className='flex flex-col'>
                <img
                  crossOrigin='anonymous'
                  className='w-64 bg-contain'
                  src={API_ROOT + "/" + objectPath.get(data, "image.0.id")}
                />
              </div>
            </div>
            <div className='flex md:w-3/4 md:mt-0 w-full'>
              <div className='flex flex-col px-4 w-full'>
                <div className='mb-2'>
                  <div className='text-disabled font-normal italic text-sm'>
                    {t("detail.material")}
                  </div>
                  <div className='md:flex hidden font-medium flex-wrap'>
                    {materiallist?.map((row, index) => {
                      return (
                        <div
                          onClick={() =>
                            setmaterial(objectPath.get(row, "_id"))
                          }
                          className={`border p-1 px-2 border-primary m-1 text-xs font-medium rounded-md hover:cursor-pointer hover:text-white hover:bg-primary ${
                            material == objectPath.get(row, "_id") &&
                            `bg-primary text-white`
                          }`}
                          key={index}
                        >
                          {objectPath.get(row, "name")}
                        </div>
                      );
                    })}
                  </div>
                  <div className='flex md:hidden'>
                    {materiallist && (
                      <Select
                        className='w-full'
                        placeholder={t("choose")}
                        value={material}
                        onChange={setmaterial}
                        getOptionValue={(option) => option._id}
                        getOptionLabel={(option) => option.name}
                        options={materiallist}
                      />
                    )}
                  </div>
                </div>
                <div className='mb-2 w-full'>
                  <div className='text-disabled font-normal italic text-sm'>
                    {t("detail.size")}
                  </div>
                  <div className='md:flex hidden font-medium flex-wrap'>
                    {sizelist?.map((row, index) => {
                      return (
                        <div
                          onClick={() => setsize(objectPath.get(row, "_id"))}
                          className={`border p-1 px-2 border-primary m-1 font-medium text-xs rounded-md hover:cursor-pointer hover:text-white hover:bg-primary ${
                            size == objectPath.get(row, "_id") &&
                            `bg-primary text-white`
                          }`}
                          key={index}
                        >
                          {objectPath.get(row, "name")}
                        </div>
                      );
                    })}
                  </div>
                  <div className='flex w-full md:hidden'>
                    {sizelist && (
                      <Select
                        className='w-full'
                        placeholder={t("choose")}
                        value={size}
                        onChange={setsize}
                        getOptionValue={(option) => option._id}
                        getOptionLabel={(option) => option.name}
                        options={sizelist}
                      />
                    )}
                  </div>
                </div>
                {size && material && (
                  <div className='flex'>
                    {priceLoading ? (
                      <Loading width='w-4' />
                    ) : (
                      <div className='flex'>
                        <div className='mb-2 mr-4'>
                          <div className='text-disabled font-normal italic text-sm'>
                            {t("detail.price")}
                          </div>
                          <div
                            className={`flex p-1 px-2 text-sm border-primary border rounded justify-center items-center font-medium hover:cursor-pointer hover:text-white hover:bg-primary ${
                              objectPath.get(priceObj, "price") == price &&
                              "bg-primary text-white"
                            }`}
                            onClick={() => {
                              setPrice(objectPath.get(priceObj, "price"));
                            }}
                          >
                            {`${objectPath
                              .get(priceObj, "price")
                              ?.toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}¥`}
                          </div>
                        </div>
                        {/* <div className="mb-2">
                          <div className="text-disabled font-normal italic text-sm">
                            Бүрэлттэй үнэ
                          </div>
                          <div
                            onClick={() => {
                              setPrice(objectPath.get(priceObj, "coat"));
                            }}
                            className={`flex  p-1 px-2 text-sm border-primary border rounded justify-center items-center font-medium hover:cursor-pointer hover:text-white hover:bg-primary ${
                              objectPath.get(priceObj, "coat") == price &&
                              "bg-primary text-white"
                            }`}
                          >
                            {`${objectPath
                              .get(priceObj, "coat")
                              ?.toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}¥`}
                          </div>
                        </div> */}
                      </div>
                    )}
                  </div>
                )}
                {size && material && price && (
                  <div className='flex flex-col'>
                    <Counter count={count} setcount={setcount} />
                    <div className='flex mt-4'>
                      <div
                        className='flex justify-center items-center rounded w-40 border border-primary p-2  hover:cursor-pointer'
                        onClick={() => basket()}
                      >
                        <div className='text-black text-base font-medium'>
                          {t("detail.basket")}
                        </div>
                      </div>
                      <NavLink
                        to='/order/basket'
                        className='flex justify-center items-center rounded w-40 border border-primary p-2 ml-4 bg-primary hover:cursor-pointer'
                      >
                        <div className='text-white text-base font-medium '>
                          {t("detail.buy")}
                        </div>
                      </NavLink>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Detail;
